module.exports = __webpack_public_path__ + "static/media/surveysBoard.ad0aa3fa.svg";